import { render, staticRenderFns } from "./InvoiceRejectModal.vue?vue&type=template&id=52379381&scoped=true"
import script from "./InvoiceRejectModal.vue?vue&type=script&lang=js"
export * from "./InvoiceRejectModal.vue?vue&type=script&lang=js"
import style0 from "./InvoiceRejectModal.vue?vue&type=style&index=0&id=52379381&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52379381",
  null
  
)

export default component.exports